import { openModal } from '@core/components/ModalStack';
import { PaybiltFormModalProps } from './PaybiltFormModal';

export async function openPaybiltFormModal(props: PaybiltFormModalProps) {
  const { PaybiltFormModal } = await import('./PaybiltFormModal');
  openModal(PaybiltFormModal, props);
}
